import { memo } from 'react';
import { Avatar } from '@ui/components';
import { IFansOfConverstion } from '@ui/components';

interface IGroupMemberItemProps {
  item: IFansOfConverstion;
  showBorder: boolean;
}

export const GroupMemberItem = memo(({ item, showBorder }: IGroupMemberItemProps) => {
  const displayName = item.display_name || item.user_name;

  return (
    <div className="group relative px-6 py-4 transition-all duration-200 hover:bg-gradient-to-r hover:from-gray-50 hover:to-white cursor-pointer">
      <div className="flex items-center gap-4">
        <div className="relative flex-shrink-0">
          <Avatar
            src={item.avatar_url}
            size="m"
            displayName={displayName}
            className="ring-2 ring-transparent group-hover:ring-orange-100 transition-all duration-200"
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-base font-semibold text-gray-900 truncate group-hover:text-orange-600 transition-colors">
            {displayName}
          </div>
          <div className="text-sm text-gray-500 truncate">@{item.user_name}</div>
        </div>
      </div>
      {showBorder && (
        <div className="absolute bottom-0 left-6 right-6 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />
      )}
    </div>
  );
});

GroupMemberItem.displayName = 'GroupMemberItem';
